import { createApiRef } from "@backstage/core-plugin-api";

export const amplifyApiRef = createApiRef<AmplifyBackendAPI>({
  id: 'plugin.amplify.service',
});

export type LastDeployStatus = {

  branchName: string,
  lastDeployStatus: string,
  lastDeployTime: string,
}


// amplify service interface
export interface AmplifyBackendAPI {
  getLastDeployStatus(branchName: string, appId: string): Promise<LastDeployStatus>;
}

